import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mb-countdown-time',
  templateUrl: './countdown-time.component.html',
  styleUrls: ['./countdown-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownTimeComponent {
  @Input() time!: number;
}
